import {AbstractAjaxForm} from './AbstractAjaxForm';

// Extend AbstractAjaxForm
MailChimpForm.prototype = Object.create(AbstractAjaxForm.prototype);
MailChimpForm.prototype.constructor = MailChimpForm;

export function MailChimpForm()
{
    const self = this;

    // Call parent constructor
    AbstractAjaxForm.call(self);

    /**
     * @inheritdoc
     */
    self.formSelector = '.mailchimp-form';

    /**
     * The CSS selector for the response messages
     * @type {String}
     */
    self.messagesSelector = '.mailchimp-response-message';

    /**
     * @inheritdoc
     */
    self.beforeCall = $form => {
        $form.find(self.messagesSelector)
            .addClass('d-none')
            .html('');
    }

    /**
     * @inheritdoc
     */
    self.handleResponse = (response, $form) => {
        const $responseMessages = $form.find(self.messagesSelector);

        if (response.success) {
            $responseMessages.filter('.message-success')
                .html(response.success)
                .removeClass('d-none');
        } else if (response.error) {
            $responseMessages.filter('.message-error')
                .html(response.error)
                .removeClass('d-none');
        }
    };
}



// WEBPACK FOOTER //
// ./resources/js/MrMovie/MailChimpAjaxForm.js